import { CriteoIntegration } from "./_criteoApi";

class CriteoConsentCheck extends CriteoIntegration {
  // Detect page context and return container + render mode
  #getPageContext() {
    const isSearch =
      window.criteoContext?.isSearch ||
      window.criteoContext?.template === "search-results-page";

    // PLP (with criteoCategory)
    if (window.criteoCategory && window.criteoCategory !== "") {
      const container = document.querySelector(
        ".snize-search-results-content.clearfix",
      );
      if (container) return { container, mode: "grid" };
    }

    // Search page (without criteoCategory)
    if (window.criteoContext?.isSearch || isSearch) {
      const container = document.querySelector(
        ".snize-search-results-content.clearfix",
      );
      if (container) return { container, mode: "grid" };
    }

    // Home / Basket / PDP → carousel mode
    const carousel = document.querySelector("#criteo-owl-carousel");
    if (carousel) return { container: carousel, mode: "carousel" };

    return null;
  }

  async run() {
    // Skip if Criteo is not active on this store
    if (!this._isActive) return;

    // Skip if marketing cookies are not blocked
    if (!this._isMarketingBlocked()) return;

    // Skip if no Criteo campaign configured on this page
    const context = this.#getPageContext();
    if (!context) return;

    this._showCookieBanner(context.container, context.mode);
  }
}

// Wait for Baycloud + Searchanise elements before running
function waitForElements(callback, maxAttempts = 20, interval = 300) {
  let attempts = 0;

  const check = () => {
    attempts++;

    const optedOut = document.querySelector(".cqdispifoptedout");
    const hasCriteoCategory =
      window.criteoCategory && window.criteoCategory !== "";
    const hasGrid = document.querySelector(
      ".snize-search-results-content.clearfix",
    );
    const hasCarousel = document.querySelector("#criteo-owl-carousel");
    const needsGrid = hasCriteoCategory || window.criteoContext?.isSearch;

    // Baycloud element must exist to detect cookie consent state
    if (!optedOut) {
      if (attempts < maxAttempts) setTimeout(check, interval);
      return;
    }

    // For PLPs: wait for Searchanise grid too
    if (needsGrid && !hasGrid) {
      if (attempts < maxAttempts) setTimeout(check, interval);
      return;
    }

    // For Home/Basket/PDP: wait for carousel container
    if (!needsGrid && !hasCarousel) {
      if (attempts < maxAttempts) setTimeout(check, interval);
      return;
    }

    // All required elements ready → run
    callback();
  };

  document.addEventListener("DOMContentLoaded", () => setTimeout(check, 300));
}

waitForElements(() => {
  new CriteoConsentCheck().run();
});
